import React from "react";

import ptBr from "../../../config/texts/pt-br";
import {
  ButtonText,
  CustomText,
  Input,
  InputAutocomplete,
  InputDate,
  Tooltip
} from "../../../components/index";
import Styles from "../styles";
import { ErrorMessageType, FormFull } from "form-full";
import { hooks, masks, validations } from "../../../utils";

import { fonts, Spacing } from "../../../config";
import { Grid } from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import alerts from "../../../utils/alerts";
import { api } from "../../../services";
import colors from "../../../config/colors";

function RegistryReservation({ reload, placeList, page }) {
  const texts = ptBr.login;

  const [totalMembers, setTotalMembers] = React.useState(0);
  const [formRef, setFormRef] = React.useState<any>(null);
  const [minDate, setMinDate] = React.useState<any>(new Date());
  const [unError, setUnError] = React.useState<any>(false);
  const [timeError, setTimeError] = React.useState<any>(false);
  const { loading, call } = hooks.useRequest();
  React.useEffect(() => {
    if (formRef) {
    }
  }, [totalMembers, formRef]);
  const drawMembers = (number: number) => {
    const membersForm: any = [];

    for (let index = 0; index < number; index++) {
      membersForm.push(
        <>
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2"
            style={{ paddingTop: "12px", paddingBottom: "4px" }}
          >
            ACOMPANHANTE #{index + 1}
          </CustomText>
          <Grid alignItems="flex-end" container spacing={1}>
            {/*  <Grid item md={6} lg={4}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                mask={masks.CPF}
                name={"cpf" + (index + 1)}
                label="CPF"
                white
                maskToSubmit={masks.removeNumberMask}
                validation={validations.validateCPF}
              />
            </Grid> */}
            <Grid item xs={12} md={12} lg={5}>
              <Input
                disableError
                name={"fullName" + (index + 1)}
                label="Nome Completo"
                white
                validation={validations.isValidFullname}
              />
            </Grid>
            {/*  <Grid item md={6} lg={4}>
              <InputDate
                disableError
                required={"*Campo Obrigatório"}
                name={"birthday" + (index + 1)}
                label="DATA NASCIMENTO"
              />
            </Grid> */}
            <Grid item xs={12} md={12} lg={7}>
              <Input
                disableError
                validation={validations.isEmailValid}
                name={"email" + (index + 1)}
                label="E-Mail"
                white
              />
            </Grid>
            {/* <Grid item md={6} lg={6}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                mask={masks.inputMaskTELWithDDD}
                name={"phone" + (index + 1)}
                label="Telefone"
                white
                maskToSubmit={masks.removeNumberMask}
              />
            </Grid> */}
          </Grid>
        </>
      );
    }
    return membersForm;
  };
  const newReservation = async (data) => {
    const submitDate = {
      numGuests: data.numberUsers ? parseInt(data.numberUsers) : 0,
      placeId: data.property,
      startDate: masks.dateToSubmit(data.startDate),
      endDate: masks.dateToSubmit(data.endDate),
      primaryGuest: {
        name: data.fullName,
        cpf: data.cpf,
        birthDate: masks.dateToSubmit(data.birthday),
        email: data.email,
        phone: data.phone
      }
    };
    const secondaryGuests: any = [];

    if (parseInt(data.numberUsers) > 0) {
      for (let index = 1; index < data.numberUsers + 1; index++) {
        if (data["fullName" + index] || data["email" + index]) {
          let newGuest = {} as any;
          if (data["fullName" + index]) {
            newGuest["name"] = data["fullName" + index];
          }
          if (data["email" + index]) {
            newGuest["email"] = data["email" + index];
          }
          secondaryGuests.push(newGuest);
        }
      }
    }
    submitDate["secondaryGuests"] = secondaryGuests;
    call(null, api.postReservation(submitDate), async (response) => {
      if (response.ok) {
        customModal.close();
        reload(page);
        alerts.setErrorModal(
          "Reserva Cadastrada",
          ["Reserva cadastrada com sucesso!"],
          null,
          "Ok, Entendi"
        );
      }
    });
  };

  const customDateValid = (data, maxDate, minDate): ErrorMessageType => {
    const error = validations.inputDate(data, maxDate, minDate);

    if (Boolean(error)) {
      setTimeError(true);
    } else {
      setTimeError(false);
    }
    return error;
  };

  const addOneDay = (date) => {
    const result = new Date(date);
    result.setDate(result.getDate() + 1);
    return result;
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(300px, 54vw, 1055px)",
          paddingInline: "25px"
        }}
      >
        <FormFull
          formRef={setFormRef}
          onSubmit={(data) => {
            newReservation(data);
          }}
        >
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2"
          >
            Dados do Imóvel e Estadia
          </CustomText>
          <Grid alignItems="flex-end" container spacing={1}>
            <Grid item xs={12} md={12} lg={7}>
              <InputAutocomplete
                disableError
                required={"*Campo Obrigatório"}
                white
                name="property"
                label="Imóvel"
                options={placeList ? placeList : []}
              />
            </Grid>{" "}
            <Grid container item xs={12} md={12} lg={5}>
              <Styles.Label $witherror={Boolean(timeError) ? true : undefined}>
                estadia*
              </Styles.Label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  gap: "15px",
                  width: "100%"
                }}
              >
                <InputDate
                  disableError
                  required={"*Campo Obrigatório"}
                  onChange={(value) => {
                    setMinDate(value);
                    const end = formRef?.getValue("endDate");

                    if (end < value) {
                      formRef?.clearValue("endDate", false);
                    }
                  }}
                  name="startDate"
                  customValidation={customDateValid}
                  minDate={new Date()}
                />{" "}
                <CustomText
                  fontFamily={fonts.medium}
                  fontSize={14 / 8}
                  textColor="#fff"
                  style={{ paddingBottom: "16px" }}
                >
                  até
                </CustomText>{" "}
                <InputDate
                  disableError
                  required={"*Campo Obrigatório"}
                  minDate={addOneDay(minDate)}
                  name="endDate"
                  customValidation={customDateValid}
                />
              </div>
            </Grid>
          </Grid>
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2"
            style={{ paddingTop: "12px", paddingBottom: "4px" }}
          >
            LOCATÁRIO PRIMÁRIO
          </CustomText>
          <Grid alignItems="flex-end" container spacing={1}>
            <Grid item xs={12} md={6} lg={5}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                mask={masks.CPF}
                name="cpf"
                label="CPF"
                white
                maskToSubmit={masks.removeNumberMask}
                validation={validations.validateCPF}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                name="fullName"
                validation={validations.isValidFullname}
                label="Nome Completo"
                white
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InputDate
                disableError
                required={"*Campo Obrigatório"}
                maxDate={new Date()}
                name="birthday"
                label="DATA NASCIMENTO"
              />{" "}
            </Grid>
            <Grid item xs={12} md={6} lg={5}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                validation={validations.isEmailValid}
                name="email"
                label="E-Mail"
                white
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                mask={masks.inputMaskTELWithDDD}
                name="phone"
                label="Telefone"
                white
                maskToSubmit={masks.removeNumberMask}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Input
                disableError
                required={"*Campo Obrigatório"}
                onChange={(value) => {
                  setTotalMembers(masks.onlyNumbers(value, 0, 10));
                }}
                defaultValue={totalMembers}
                mask={(value) => masks.onlyNumbers(value, 0, 10)}
                maskToSubmit={(value) => masks.onlyNumbers(value, 0, 10)}
                type="number"
                name="numberUsers"
                label="Nº ACOMPANHANTES"
                white
              />
            </Grid>
          </Grid>
          {drawMembers(totalMembers)}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              paddingTop: "12px",
              width: "100%"
            }}
          >
            <CustomText fontSize={1.75} textColor="#f00">
              {unError && "*Campos Obrigatórios "}
              {timeError && "*Data de início deve ser menor que a data de fim"}
            </CustomText>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px"
              }}
            >
              <Styles.CancelButton
                loading={loading}
                disabled={loading}
                onClick={() => {
                  customModal.close();
                }}
                fullWidth={false}
              >
                Cancelar
              </Styles.CancelButton>
              <Styles.RegitryButton
                fullWidth={false}
                loading={loading}
                disabled={loading}
                onClick={async () => {
                  const submitInfo = await formRef?.testErrorsAndReturnData();
                  const startError = await formRef?.testFieldError("startDate");
                  const endError = await formRef?.testFieldError("endDate");

                  if (startError || endError) {
                    setTimeError(true);
                  } else {
                    setTimeError(false);
                  }

                  if (submitInfo?.hasError) {
                    setUnError(true);
                  } else {
                    setUnError(false);
                    formRef?.submit();
                  }
                }}
              >
                Confirmar Cadastro
              </Styles.RegitryButton>
            </div>
          </div>
        </FormFull>
      </div>
    </>
  );
}

export default RegistryReservation;
